import {View} from "react-native";
import AppTextInput from "./AppTextInput";
import React, {useCallback, forwardRef} from "react";
import EStyleSheet from "react-native-extended-stylesheet";

export const EmailInput = forwardRef(({
    label,
    value,
    onChangeText,
    validationCallback,
    style = null,
    wrapperStyle = {},
    labelStyle = {},
    inputStyle = {},
    ...rest
                           }, ref) => {

    const validateEmail = useCallback((email) => {
        const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return regex.test(email);
    }, []);

    const updateText = useCallback((text) => {
        onChangeText(text);
        if (validationCallback) {
            const isValid = validateEmail(text);
            validationCallback(isValid);
        }
    }, [validateEmail, validationCallback]);

    return <View style={[
        styles.inputWrapper,
        style,
    ]}>
        <AppTextInput
            ref={ref}
            label={label}
            value={value}
            onChangeText={value => updateText(value)}
            wrapperStyle={wrapperStyle}
            labelStyle={labelStyle}
            inputStyle={inputStyle}
            {...rest}
        />
    </View>
});

const styles = EStyleSheet.create({
    contentWrapper: {
        padding: 32,
        width: 400,
        maxWidth: '100%',
        marginBottom: 12,
    },
    inputWrapper: {

    },
    inputLabel: {

    },

    validationWrapper: {
        position: 'absolute',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        bottom: -2,
    },
    validationText: {
        fontFamily: 'SourceSansPro-light',
        fontSize: 12,
    },
    validationTextValid: {
        color: '#00d895'
    },
    validationTextInvalid: {
        color: 'red'
    },
});
